import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-4 border-t border-slate-800" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-47">
        <p className="text-sm" data-id="element-48">
          © 2026 Sistema PRO: Podología. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}